/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiserviceMelcoModelsPreview
 */
export interface ApiserviceMelcoModelsPreview {
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsPreview
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsPreview
     */
    url?: string | null;
}

export function ApiserviceMelcoModelsPreviewFromJSON(json: any): ApiserviceMelcoModelsPreview {
    return ApiserviceMelcoModelsPreviewFromJSONTyped(json, false);
}

export function ApiserviceMelcoModelsPreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiserviceMelcoModelsPreview {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function ApiserviceMelcoModelsPreviewToJSON(value?: ApiserviceMelcoModelsPreview | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'url': value.url,
    };
}


